import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FavoriteCardTypeEnum, UserFavoriteCardData } from '../../../user-favorite-data.model';
import { Currency } from '../../../../../model/landingModel';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { OfferCardSubtype, OfferCardType } from 'projects/common/components/offers/offer-card-data.model';

@Component({
  selector: 'flights-card',
  template: `
    <div class="{{data.offer_card_type}}">
      <div class="main-text border"
      *ngIf="cardType === 'REDUCED'">
      {{ data.main_text }}
      </div>
      <div *ngIf="shouldShowCardHeader()" class="spacing top bottom border basic-header-wrapper">
        <card-header
          [showDeleteBtn]="showDeleteBtn"
          (onDeleteFavoriteClick)="onDeleteFavoriteClick.emit()"
          [externalId]="data.external_id"
          [product]="data.product"
          [flow]="flow"
        >
          <flights-header [data]="data" [locale]="locale" [flow]="flow" [cardType]="cardType"></flights-header>
        </card-header>
      </div>

      <div *ngIf="shouldShowBasicMainText()" class="basic-main-text-wrapper">
        <div class="basic-main-text">
          {{ data.main_text }}
        </div>
        <ng-container *ngIf="shouldShowAirlineLogos()">
          <div class="airline-logos-container">
            <ng-container *ngFor="let airline of data.airlines">
              <img class="airline-logo" [src]="mediaPictureService.getMediaUrl(airline.logo_url)" [alt]="airline.name"/>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div *ngIf="shouldShowItinerary()" class="itinerary-wrapper {{cardType}}"
        [ngClass]="{'border': cardType !== FavoriteCardTypeEnum.REDUCED}">
        <favorite-card-flight-itinerary [data]="data" [baggage]="data.baggage" [locale]="locale" [flow]="flow" [cardType]="cardType" [position]="position">
        </favorite-card-flight-itinerary>
      </div>

      <pricebox-with-points *ngIf="shouldShowPriceboxWithPoints()" [price]="data.price[currency.code]" [currency]="currency" [locale]="locale"></pricebox-with-points>

      <div class="spacing top bottom basic-pricebox"
        *ngIf="shouldShowBasicPricebox()">
        <favorite-card-pricebox
          [currency]="currency"
          [locale]="locale"
          [showAlertBtn]="showAlertBtn"
          [isWhiteLabel]="isWhiteLabel"
          [data]="data"
          [moduleId]="moduleId"
          [moduleIndex]="moduleIndex"
          [isWhiteLabel]="isWhiteLabel"
          [showAlertBtn]="showAlertBtn"
          [nextFlow]="nextFlow"
          [uniqueId]="uniqueId"
        ></favorite-card-pricebox>
      </div>
    </div>
  `,
  styleUrls: ['./flights-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FlightsCardComponent {
  @Input() data: UserFavoriteCardData;
  @Input() moduleId: string;
  @Input() uniqueId: string;
  @Input() moduleIndex: number;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() isWhiteLabel: boolean;
  @Input() showAlertBtn: boolean;
  @Input() flow: string;
  @Input() showDeleteBtn: boolean;
  @Input() cardType: FavoriteCardTypeEnum;
  @Input() position: number;
  @Input() nextFlow: string;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDeleteFavoriteClick = new EventEmitter();

  FavoriteCardTypeEnum = FavoriteCardTypeEnum;

  constructor(public mediaPictureService: MediaPictureService) { }

  shouldShowCardHeader(): boolean {
    // Lógica exactamente equivalente a la original sin validaciones adicionales
    const isBasicCard = this.data?.offer_card_type === OfferCardType.BASIC;
    if (!isBasicCard) return true;

    const isMultidestinationSingleProduct = this.data?.offer_card_subtype === OfferCardSubtype.MULTIDESTINATION_SINGLE_PRODUCT;
    const isAirline = this.data?.offer_card_subtype === OfferCardSubtype.AIRLINE;
    const isSingleDestinationWithMultidestinationModule =
      this.data?.offer_card_subtype === OfferCardSubtype.SINGLE_DESTINATION_SINGLE_PRODUCT &&
      this.moduleId === 'MultidestinationFlightsModule';

    return !(isMultidestinationSingleProduct || isAirline || isSingleDestinationWithMultidestinationModule);
  }

  shouldShowAirlineLogos(): boolean {
    if (!this.data) return false;

    return this.data.offer_card_subtype !== OfferCardSubtype.MULTIDESTINATION_MULTIPRODUCT &&
      this.data.offer_card_subtype !== OfferCardSubtype.AIRLINE;
  }

  shouldShowItinerary(): boolean {
    if (!this.data?.itineraries) return false;

    const isBasicMultidestinationSingleProduct =
      this.data.offer_card_type === OfferCardType.BASIC &&
      this.data.offer_card_subtype === OfferCardSubtype.MULTIDESTINATION_SINGLE_PRODUCT;

    return !isBasicMultidestinationSingleProduct;
  }

  shouldShowPriceboxWithPoints(): boolean {
    if (!this.data?.price?.[this.currency?.code]) return false;

    return !!this.data.price[this.currency.code]?.prepaid_price_in_points &&
      !this.data?.price_child &&
      this.cardType !== FavoriteCardTypeEnum.REDUCED;
  }

  shouldShowBasicPricebox(): boolean {
    if (!this.data?.price?.[this.currency?.code]) return false;

    return !this.data.price[this.currency.code]?.prepaid_price_in_points &&
      this.cardType !== FavoriteCardTypeEnum.REDUCED;
  }

  shouldShowBasicMainText(): boolean {
    return this.data?.offer_card_type === OfferCardType.BASIC && !!this.data?.main_text;
  }

}
